import { actionsFactories } from 'store/features/utils';

export const deleteAccount = actionsFactories.createSingleFeatureActionsFactory()(
  'DELETE_ACCOUNT_REQUEST',
  'DELETE_ACCOUNT_SUCCESS',
  'DELETE_ACCOUNT_FAILURE',
  'DELETE_ACCOUNT_RESET',
);
